import { buildDockEntity } from './marker_utils'

class DockMarker {
  constructor ({ cesiumViewer, serialNumber }) {
    this._cesiumViewer = cesiumViewer // May be null at construction time
    this._entity = null

    this.serialNumber = serialNumber
    this.name = null
    this.position = null
  }

  get entity () {
    return this._entity
  }

  get dockId () {
    return 'dock_' + this.serialNumber
  }

  get dockName () {
    if (!this.name) {
      return 'Dock: ' + this.serialNumber
    }

    return this.name
  }

  update ({ name, position }) {
    if (name) this.name = name // Optional custom name

    if (position && position.latitude && position.longitude) {
      this.position = Cesium.Cartesian3.fromDegrees(position.longitude, position.latitude)
    }

    this._refreshEntity()
  }

  _refreshEntity () {
    // Ensure we have the necessary data
    if (!this.position) return

    if (this._entity) {
      // Update existing entity
      this._entity.position = this.position
      this._entity.name = this.dockName
    } else if (this._cesiumViewer) {
      // Create new entity
      this._entity = buildDockEntity({
        cesiumViewer: this._cesiumViewer,
        id: this.dockId,
        name: this.dockName,
        position: this.position
      })
    }
  }
}

export const withDockMarkers = (_controller, { cesiumViewer }) => {
  const dockMarkers = new Map()

  return {
    update: (dockData) => {
      const serialNumber = dockData.serial_number
      if (!serialNumber) return

      let dockMarker = dockMarkers.get(serialNumber)
      if (!dockMarker) {
        dockMarker = new DockMarker({ cesiumViewer, serialNumber })
        dockMarkers.set(serialNumber, dockMarker)
      }

      dockMarker.update(dockData)
    },
    getEntity: () => {
      // Return the first Dock Entity (for now)
      for (const dockMarker of dockMarkers.values()) {
        const entity = dockMarker.entity
        if (entity) return entity
      }
      return null
    }
  }
}
